(function () {
  'use strict';

  var SELECTOR = '[data-pf-add-variant]';

  function normalizeVariantId(value) {
    var variantId = Number(value);
    return Number.isInteger(variantId) && variantId > 0 ? variantId : null;
  }

  async function addVariant(variantId, quantity) {
    var id = normalizeVariantId(variantId);
    var count = Math.max(1, Number(quantity) || 1);
    if (!id) throw new Error('This product option is unavailable.');

    async function postAdd() {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: count }] })
      });
      var payload = await response.json().catch(function () { return {}; });
      if (!response.ok) throw new Error(payload.description || 'Unable to add item.');
      return { response: payload, rendered: false, changed: true };
    }

    /* The paid line is the add; free gifts are a follow-up. Awaiting the
       whole reward pass (addProductWithRewards) kept the button busy for the
       promotion plan round-trip and, when that later step failed, reported
       "Unable to add" for a product already in the cart. withCartMutation
       serializes this add with reward mutations; pristine:cart:changed then
       asks the embed to settle rewards in the background (its errors surface
       through the embed's own UI, never as a failed add). */
    var controller = window.PristinePreorderCart;
    var result;
    if (controller && typeof controller.withCartMutation === 'function') {
      result = await controller.withCartMutation(postAdd);
    } else if (controller && typeof controller.addProductWithRewards === 'function') {
      var form = new FormData();
      form.set('id', String(id));
      form.set('quantity', String(count));
      result = await controller.addProductWithRewards(form);
    } else {
      result = await postAdd();
    }
    if (!result || result.plan === undefined) {
      window.dispatchEvent(new CustomEvent('pristine:cart:changed'));
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { source: 'pf-product-actions', variantId: id, quantity: count, added: count }
    }));
    return result;
  }

  async function onClick(event) {
    var button = event.target && event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();

    var variantId = button.getAttribute('data-variant-id');
    var idle = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.getAttribute('data-busy-label') || 'Adding…';
    var addRequest = addVariant(variantId, button.getAttribute('data-quantity'));
    var card = button.closest('article');
    var titleNode = card && card.querySelector('.carousel__hv-title, .desktop-trending__name');
    var title = titleNode && titleNode.children.length
      ? Array.from(titleNode.children).map(function (part) { return part.textContent.trim(); }).join(' ')
      : titleNode && titleNode.textContent.trim();
    var note = window.PFMotion && window.PFMotion.leafNote
      ? window.PFMotion.leafNote(title) : null;
    try {
      await addRequest;
      if (note) note.added();
      button.textContent = button.getAttribute('data-added-label') || 'Added';
      window.setTimeout(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = idle;
      }, 1400);
    } catch (error) {
      if (note) note.failed();
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = idle;
      window.alert((error && error.message) || 'Unable to add item.');
    }
  }

  document.addEventListener('click', onClick);
  window.PFProductActions = Object.freeze({ addVariant: addVariant });
})();
